<layer-header (closeLayer)="closeLayer()"
              (setListView)="setListView($event)"
              [listToggle]="listToggle"
              [title]="'Results'">
    <ng-content></ng-content>
</layer-header>
<result-edit *ngIf="topLayer == 'edit'"
              [documentResult]="documentResult"
              [determinantMapById]="determinantMapById"
              [serviceId]="serviceId"
              [registration]="registration"
              [addNew]="addNew"
              (editCancel)="cancelEdit($event);"
              (formSubmit)="resultWindowSubmitted($event);"
              class="row layer sub-layer px-3 pt-1">
</result-edit>
<div class="row">
    <div class="col-md-1">
    </div>
    <div class="col-lg-12 col-xl-11">
        <!-- Search -->
        <div class="row">
            <div class="col-md-12 col-xl-6">
                <div class="form-controller list-search-container">
                    <input type="text"
                           [(ngModel)]="userFilter.name"
                           placeholder="{{ 'general.search' | translate }}"
                           class="form-control list-search-input flew-grow-1">
                    <button class="btn btn-sm btn-primary mr-1"
                       (click)="openEdit(false);$event.stopPropagation();"
                       placement="left"
                       aria-hidden="true">{{'Add' | translate}}</button>
                </div>
            </div>
        </div>
        <!-- Listing -->
        <div class="{{listToggle ? 'cards-list' : 'rows-list'}} row"
             style="margin-bottom:2rem">
            <div *ngFor="let item of documentResultList | filterBy: {requirement:{name:userFilter.name}}; let i = index"
                 class="nglist-item {{listToggle ? 'col-sm-6 col-md-4 col-lg-3' : 'col-md-12 col-xl-6'}}"
                 (click)="openEdit(item);$event.stopPropagation();">
                <div class="nglist-item-content">
                    <span class="nglist-item-content-title">
                      {{item.requirement.name}}
                    </span>
                </div>
                <div class="nglist-item-actions alternate">
                    <icon style="margin-inline-end: 0.5rem;color:#8ecb35"
                          className="fas fa-check icon-success"
                          (click)="deleteDocResult(item);$event.stopPropagation();"></icon>
                    <confirmation [showTrashIcon]="true"
                                  [question]="'confirm.areyousure'"
                                  [extraClasses]="'nglist-item-action'"
                                  (click)="$event.stopPropagation();"
                                  (isConfirmed)="deleteRequirement($event, item)"></confirmation>
                </div>
            </div>
            <div *ngFor="let item of requirements | filterBy: {name:userFilter.name}; let i = index"
                 class="nglist-item {{listToggle ? 'col-sm-6 col-md-4 col-lg-3' : 'col-md-12 col-xl-6'}}"
                 (click)="openEdit(item);$event.stopPropagation();">
                <div class="nglist-item-content">
                    <span class="nglist-item-content-title">
                      {{item.name}}
                    </span>
                </div>
                <div class="nglist-item-actions alternate">
                    <icon style="margin-inline-end: 0.5rem;"
                          className="far fa-circle toggle__icon"
                          (click)="addDocResult(item);$event.stopPropagation();"></icon>
                    <confirmation [showTrashIcon]="true"
                                  [question]="'confirm.areyousure'"
                                  [extraClasses]="'nglist-item-action'"
                                  (click)="$event.stopPropagation();"
                                  (isConfirmed)="deleteRequirement($event, item)"></confirmation>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-1">
    </div>
</div>